/* eslint-disable tailwindcss/no-arbitrary-value */
import { Modal, ModalBody, ModalHeader } from '@one-thd/sui-atomic-components';
import { ConfirmedFilled } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { GetQBOrderCount } from '../../../../hooks/purchase-history-hooks';
import { getWindow } from '../../../../utils/general';
import QBDesktopExportWalkthrough from './QBDesktopExportWalkthrough';
import QuickBooksDesktopExport from './QuickBooksDesktopExport';
import QuickBooksExportButton from './QuickBooksExportButton';
import QuickBooksOnlineExport from './QuickBooksOnlineExport';
var qbFeatures = {
    online: [
        'QuickBooks Simple',
        'QuickBooks Essential',
        'QuickBooks Plus',
        'QuickBooks Advanced',
    ],
    desktop: [
        'QuickBooks Enterprise',
        'QuickBooks Accountant',
        'QuickBooks Premier',
        'QuickBooks Pro',
    ],
};
var getModalTitle = {
    desktop: 'QuickBooks Desktop Export',
    online: 'QuickBooks Online Export',
    walkthrough: 'Export Desktop Walkthrough',
};
var renderSectionTitle = function (title) {
    var applyInverseBorder = title === 'Online' ? 'sui-border-r-primary' : 'sui-border-l-primary';
    return (React.createElement("div", { className: "sui-flex sui-justify-center sui-items-center sui-bg-[#5fac47] sui-text-inverse sui-mb-6 sui-min-w-full sui-h-8 sui-text-xl ".concat(applyInverseBorder) }, title));
};
var featureList = function (features) {
    return (React.createElement("div", { className: "sui-mx-2 sui-border-t-1 sui-border-strong sui-border-solid", "data-testid": "quickbooks-selector-feature-list" }, features.map(function (feature, index) { return (React.createElement("div", { key: index, className: "sui-flex sui-items-center sui-justify-start sui-text-xl sui-pl-5 sui-pb-1 sui-gap-1 first:sui-mt-6" },
        React.createElement("div", { className: "sui-fill-[#5fac47] sui-pb-1" },
            React.createElement(ConfirmedFilled, { color: "inherit" })),
        React.createElement("div", { "data-testid": "quickbooks-selector-feature" }, feature))); })));
};
var onlineDesktopSelectorElement = function (setQBRenderFlag, qbCount, setOpenModal, setAlertState) {
    var _a, _b;
    var screenWidth = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.screen) === null || _b === void 0 ? void 0 : _b.width;
    return (React.createElement(ModalBody, null,
        React.createElement("div", { className: "sui-grid sui-grid-cols-2 sui-justify-center sui-relative" },
            React.createElement("div", { style: {
                    position: 'absolute',
                    top: '15%',
                    left: '50%',
                    transform: 'translate(-50%, -20%)',
                } },
                React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/OrSymbol.svg", alt: "Or Symbol", width: "56px", height: "56px" })),
            React.createElement("div", { className: "sui-col-span-1 sui-border-solid sui-border-strong sui-border-1 " },
                renderSectionTitle('Online'),
                React.createElement("div", { className: "sui-flex sui-align-center sui-justify-center sui-mb-4" },
                    React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/OnlineTitle.svg", alt: "Online Title", width: "80%", height: "78px", style: {
                            paddingBottom: screenWidth && screenWidth > 1440 ? '10px' : '7px',
                        }, className: "sui-mt-2" })),
                featureList(qbFeatures.online),
                React.createElement(QuickBooksExportButton, { isDesktopExport: false, setQBRenderFlag: setQBRenderFlag, setOpenModal: setOpenModal, setAlertState: setAlertState, qbCount: qbCount })),
            React.createElement("div", { className: "sui-col-span-1 sui-border-solid sui-border-strong sui-border-1" },
                renderSectionTitle('Desktop'),
                React.createElement("div", { className: "sui-flex sui-align-center sui-justify-center sui-mb-3" },
                    React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/DesktopTitle.svg", alt: "Desktop Title", width: "80%", height: "78px", className: "sui-mt-2" })),
                featureList(qbFeatures.desktop),
                React.createElement(QuickBooksExportButton, { isDesktopExport: true, setQBRenderFlag: setQBRenderFlag, setOpenModal: setOpenModal, setAlertState: setAlertState })))));
};
var modalBodyRenderLogic = function (qbRenderFlag, setQBRenderFlag, qbCount, setOpenModal, setAlertState, request) {
    if (qbRenderFlag === 'online') {
        return (React.createElement(QuickBooksOnlineExport, { setQBRenderFlag: setQBRenderFlag, request: request, setOpenModal: setOpenModal, setAlertState: setAlertState }));
    }
    if (qbRenderFlag === 'desktop') {
        return (React.createElement(QuickBooksDesktopExport, { setQBRenderFlag: setQBRenderFlag, request: request, setOpenModal: setOpenModal, setAlertState: setAlertState }));
    }
    if (qbRenderFlag === 'walkthrough') {
        return React.createElement(QBDesktopExportWalkthrough, { setQBRenderFlag: setQBRenderFlag });
    }
    return onlineDesktopSelectorElement(setQBRenderFlag, qbCount, setOpenModal, setAlertState);
};
var QuickBooksModal = function (_a) {
    var openModal = _a.openModal, setOpenModal = _a.setOpenModal, request = _a.request, setAlertState = _a.setAlertState;
    var _b = useState(), qbRenderFlag = _b[0], setQBRenderFlag = _b[1];
    var qbCount = GetQBOrderCount(request, openModal);
    var handleCloseAndReset = function () {
        setOpenModal(false);
        setTimeout(function () { return setQBRenderFlag(undefined); }, 1000);
    };
    return (React.createElement(Modal, { open: openModal, onClose: handleCloseAndReset, size: qbRenderFlag === undefined ? 'lg' : 'md' },
        React.createElement(ModalHeader, { onClose: handleCloseAndReset }, qbRenderFlag
            ? getModalTitle[qbRenderFlag]
            : 'Quickbooks Export Selection'),
        modalBodyRenderLogic(qbRenderFlag, setQBRenderFlag, qbCount, setOpenModal, setAlertState, request)));
};
export default QuickBooksModal;
